import { Component, Watch, Vue } from 'vue-property-decorator';
import NavSide from '../../shared/NavSide/nav.side.vue';
import Header from '../../shared/Header/header.vue';
import ReportsIntro from './ReportsIntro/reports.intro.vue';
import ReportsList from './ReportsList/reports.list.vue';
import SpinLoader from '../../shared/SpinLoader/spin.loader.vue';

@Component({
   components: {
      NavSide,
      Header,
      ReportsIntro,
      SpinLoader,
      ReportsList
   },
})
export default class ReportsPage extends Vue {
   public title: string = 'ReportsPage';

   public isLoading: boolean = false;

   public created() {
      this.$store.commit('selectSection', '3');
   }

   @Watch('$store.state.reports.isFetching', { immediate: true, deep: true })
   public onLoading(val: any, oldVal: any) {
      this.isLoading = val;
   }

}
